import ServiceBus from "servicestack/service-bus";
import basicController from "servicestack/basic.controller.properties";

export default class ApplyTagsPromptController {
  constructor(options) {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.bus = new ServiceBus();
    console.debug("ApplyTagsPromptController", { $ctrl, options });
    const { request = {}, title } = options;

    $ctrl.request = {
      tags: {},
      ...request
    };
    $ctrl.title = title;
  }

  $onInit() {
    const $ctrl = this;
    $ctrl.model = $ctrl;
    if (!Array.isArray($ctrl.rows)) {
      $ctrl.rows = [];
    }
    if ($ctrl.rows.length === 0) {
      $ctrl.addRow();
    }
    $ctrl.tagKinds = [];
    $ctrl.bus
      .read("QueryProductTagKinds.json")
      .then(res => ($ctrl.tagKinds = res.data.results.map(r => r.tagKind)));
  }

  addRow(index) {
    if (index !== undefined)
      this.rows.splice(index, 0, { kind: "", labels: [] });
    else this.rows.push({ kind: "", labels: [] });
  }

  removeRow(index) {
    this.rows.splice(index, 1);
  }

  submit() {
    const $ctrl = this;
    const { tags } = $ctrl.request;
    for (const row of $ctrl.rows) {
      if (row.kind in tags) {
        tags[row.kind].push(...row.labels);
      } else {
        tags[row.kind] = row.labels;
      }
    }
    $ctrl.bus
      .send("ApplyProductTags.json?Profiler=Enabled", $ctrl.request)
      .then(res => $ctrl.$close(res));
  }
}
